import {isString, split} from 'lodash';

const compareVersions = (firstVersion: string, secondVersion: string) => {
    if (!isString(firstVersion) && !isString(secondVersion)) {
        return 0;
    } else if (!isString(firstVersion)) {
        return -1;
    } else if (!isString(secondVersion)) {
        return 1;
    }
    const firstChunks = split((firstVersion || ''), '.');
    const secondChunks = split((secondVersion || ''), '.');
    const count = Math.min(firstChunks.length, secondChunks.length);
    for (let i = 0; i < count; ++ i) {
        const first = parseInt(firstChunks[i]);
        const second = parseInt(secondChunks[i]);
        if (first > second) {
            return 1;
        }
        if (first < second) {
            return -1;
        }
    }
    if (firstChunks.length === secondChunks.length) {
        return 0;
    }
    return firstChunks.length < secondVersion.length ? -1 : 1;
};

const isLess = (firstVersion: string, secondVersion: string) => compareVersions(firstVersion, secondVersion) === -1;

export const versionUtils = {
    compareVersions,
    isLess
};